class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.initHover();
  }

  initHover() {
    if (!('matchMedia' in window)) return;
    const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

    this.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      clearTimeout(this.closeTimeout);

      // Close other open menus
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this) {
          clearTimeout(menu.closeTimeout);
          menu.close();
        }
      });

      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', '');
        this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
        this.onToggle();
      }
    });

    this.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      this.closeTimeout = setTimeout(() => {
        this.close();
      }, 150);
    });

    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', (e) => {
        if (isDesktop() && this.mainDetailsToggle.hasAttribute('open')) {
          e.preventDefault();
        }
      });
    }

    // Support nested submenus (Level 2 to Level 3) if dropdown menu is used
    const nestedSubmenus = this.querySelectorAll('.header__submenu details');
    nestedSubmenus.forEach((subDetails) => {
      let subTimeout;
      subDetails.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        clearTimeout(subTimeout);
        subDetails.setAttribute('open', '');
        subDetails.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      });
      subDetails.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        subTimeout = setTimeout(() => {
          subDetails.removeAttribute('open');
          subDetails.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        }, 150);
      });
    });

    // Close open menus immediately when hovering over adjacent simple links
    const inlineMenu = document.querySelector('.header__inline-menu');
    if (inlineMenu && !inlineMenu.dataset.hoverInitialized) {
      inlineMenu.dataset.hoverInitialized = 'true';
      inlineMenu.querySelectorAll('a.header__menu-item').forEach((link) => {
        link.addEventListener('mouseenter', () => {
          if (!isDesktop()) return;
          document.querySelectorAll('header-menu').forEach((menu) => {
            clearTimeout(menu.closeTimeout);
            menu.close();
          });
        });
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

